import { alpha } from '@mui/material/styles';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    searchField: {
        marginLeft: theme.spacing(1),
        width: "100%",
        maxWidth: 400
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: "100%",
        marginRight: theme.spacing(3)
    },
    inputRoot: {
        backgroundColor: alpha(theme.palette.common.white, 0.1)
    },
    numResultsContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: "solid white 1px",
        borderRadius: "50%",
        backgroundColor: alpha(theme.palette.common.white, 0.5),
        padding: 8,
        width: 35,
        height: 35,
        fontSize: 18,
        fontWeight: "bold",
        textAlign: "center",
        color: theme.palette.common.black
    },
    numResults: {
        minWidth: 20
    }
}));

export {useStyles};
